<template>
  <div class="about">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-3">
          <div class="input-group form-group-lg mb-3">
            <input
                v-model="search"
                type="text"
                class="form-control input-lg"
                placeholder="Search"
                aria-label="Username"
                aria-describedby="basic-addon1">
          </div>

          <div class="mt-4 d-none d-lg-block">
            <div v-for="(filterList, key) in filters" :key="key">
              <h5 class="mt-3">{{filtersTitle[key]}}</h5>
              <div class="form-check" v-for="(filter, i) in filterList" :key="filter">
                <input class="form-check-input"
                       type="checkbox"
                       :value='filter'
                       v-model="activeFilters[key]"
                       :id="`${key}${i}`"
                >
                <label class="form-check-label" :for="`${key}${i}`">
                  {{ filter }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <transition-group class="my-group row" name="list" tag="div">
            <Product v-for="product in filteredProducts" :key="product._id" :product="product"/>
          </transition-group>
          <h4 v-if="!filteredProducts.length">
            No such product
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/components/Product.vue';
import store from '@/store';
import axios from 'axios';
import filterObject from '@/util/lang';

export default {
  data() {
    return {
      search: '',
      filtersTitle: {
        brand: '',
        country_of_production: '',
        category: '',
        continent: '',
      },
      activeFilters: {
        brand: [],
        country_of_production: [],
        category: [],
        continent: [],
      },
    };
  },
  components: {
    Product,
  },
  methods: {
    getFilterHeaders() {
      axios
        .get('/admin/api/collections/get/products_filters')
        .then(({ data: { entries } }) =>
          entries.map(el => filterObject(el, store.getters.lang)),
        )
        .then(entries => {
          [this.filtersTitle] = entries;
        });
    },
  },
  created() {
    this.getFilterHeaders();
    store.watch(
      state => state.lang,
      () => {
        this.getFilterHeaders();
      },
    );
  },
  computed: {
    filters() {
      return {
        brand: filterObject(store.getters.brands, store.getters.lang),
        country_of_production: filterObject(
          store.getters.countryOfProduction,
          store.getters.lang,
        ),
        category: filterObject(store.getters.category, store.getters.lang),
        continent: filterObject(store.getters.continent, store.getters.lang),
      };
    },
    products() {
      return store.getters.products;
    },
    filteredProducts() {
      console.log('computed');
      let finalValue = this.products;
      finalValue = finalValue.filter(el =>
        Object.keys(this.activeFilters).every(
          filterCategory =>
            !this.activeFilters[filterCategory].length
              ? true
              : this.activeFilters[filterCategory].some(
                  selectedFilter => el[filterCategory] === selectedFilter,
                ),
        ),
      );
      if (this.search) {
        finalValue = finalValue.filter(
          el =>
            el.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
            el.brand.toLowerCase().indexOf(this.search.toLowerCase()) !== -1,
        );
      }
      return finalValue.sort((a, b) => {
        if (Number(a.order) > Number(b.order)) {
          return 1;
        }
        if (Number(a.order) < Number(b.order)) {
          return -1;
        }
        return 0;
      });
    },
  },
};
</script>

<style>
.form-check {
  padding-left: 0;
}
.form-check-input {
  opacity: 0;
}
.form-check-label {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.form-check-label:hover {
  cursor: pointer;
}
.form-check-label:before {
  display: flex;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #40312e;
  content: '';
  margin-right: 8px;
  line-height: 16px;
  justify-content: center;
  align-items: center;
}
input:checked + .form-check-label:before {
  background-color: #40312e;
  content: '+';
  color: #fff;
  display: flex;
}
.portfolio-item {
  margin-bottom: 30px;
}
.list-group-item.active {
  color: #fff !important;
}
.list-move {
  transition: transform 1s;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
